import axios from 'axios'

import {
  ApiErrorHolder,
  toApiError
} from '@espoon-voltti/nuora-app-common/services/error'

export * from './auth'
export * from './apps'
export * from './grant-periods'
export * from './orgs'

export function init() {
  axios.interceptors.response.use(
    (response) => response,
    (err) => Promise.reject(new ApiErrorHolder(toApiError(err)))
  )
}
